export function normalizeAppRoute(route: string): string  {


  const trimmed = route.trim();


  const absolute = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  const collapsedSlashes = absolute.replace(/\/{2,}/g, "/");
  return collapsedSlashes.length > 1 ? collapsedSlashes.replace(/\/+$/, "") : collapsedSlashes;
}

export function getAppRoutePattern(route: string): string {
  return `${route}/*`;
}
